import { Col, Container, Row } from 'react-bootstrap';
import { PageTitle } from 'shared/components/Fonts';
import { UserForm } from 'user/share/components/UserForm/UserForm';
import { useContext } from 'react';
import { UserInfoContext } from 'user/context/UserInfoContext';

export function UserFormPage() {
  const { isCreationPage } = useContext(UserInfoContext);
  const title = isCreationPage ? 'Creación de Usuario' : 'Modificación de Usuario';

  return (
    <Container fluid>
      <Row className="mb-3">
        <PageTitle>{title}</PageTitle>
      </Row>

      <Row>
        <Col>
          <UserForm />
        </Col>
      </Row>
    </Container>
  );
}
